module.exports = __webpack_public_path__ + "img/checkedBox.ccd4452a.svg";